// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGetProductCollectionRealTimeInventory } from "@eisinc/App/Services/ProductServiceV2";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { getSettingsCollection, getShouldLoadInventory } from "@insite/client-framework/Store/Context/ContextSelectors";

export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    const { productSettings, websiteSettings } = getSettingsCollection(props.getState());
    if (!productSettings.showInventoryAvailability) {
        return;
    }

    if (!getShouldLoadInventory(props.getState())) {
        props.dispatch({ type: "Context/AddDeferredApiCall", deferredCallType: "inventory" });
        return false;
    }

    try {
        // XNG-Changes
        props.apiResult = await xGetProductCollectionRealTimeInventory(props.apiParameter);
    } catch (error) {
        logger.warn(`Failed to load inventory data: ${error}`);
        props.error = error;
    }
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
